<template>
    <div class="simple-fold-block">
        <div class="shade-top"></div>
        <template v-if="bgVideoMobile">
            <video ref="bgImage" class="show-desktop sf-fade-hook" preload="metadata" muted autoplay loop :poster="bgStyle" webkit-playsinline playsinline>
                <source :src="bgVideo" type="video/mp4">
            </video>
            <video ref="bgImageMobile"  class="show-mobile sf-fade-hook" preload="metadata"  muted autoplay loop :poster="bgStyleMobile" webkit-playsinline playsinline>
                <source :src="bgVideoMobile" type="video/mp4">
            </video>
        </template>
        <template v-else-if="bgVideo">
            <video ref="bgImage" preload="metadata" class="sf-fade-hook" muted autoplay loop :poster="bgStyle" webkit-playsinline playsinline>
                <source :src="bgVideo" type="video/mp4">
            </video>
        </template>
        <template v-else-if="bgStyleMobile">
            <div class="bgimg show-desktop sf-fade-hook" :style="bgStyle" ref="bgImage" />
            <div class="bgimg show-mobile sf-fade-hook" :style="bgStyleMobile" ref="bgImageMobile" />
        </template>
        <template v-else>
            <div class="bgimg sf-fade-hook" :style="bgStyle" ref="bgImage" />
        </template>
        <div class="shade-bottom"></div>
        <div class="capper">
            <div class="capper-padded-2x">
                <div class="copy">
                    <h2 ref="subtitle" v-html="subtitle"></h2>
                    <h1 ref="title" v-html="gh.nl2br(title)"></h1>
                </div>
            </div>
        </div>
        <span v-if="youtubeId" class="icon">
            <VideoPlay2 @click="openYoutube(youtubeId)" />
        </span>
    </div>
</template>

<script>
import gsap from "@/plugins/gsap";
import SplitText from "@/plugins/gsap/SplitText";
import gh from "@/helpers/gh";
import VideoPlay2 from "@/components/svgs/VideoPlay2.vue";
gsap.registerPlugin(SplitText);

export default {
    name: "SimpleFold",
    components: {VideoPlay2},
    props: {
        bgStyle: {
            type: String,
            required: true,
        },
        bgStyleMobile: {
            type: String,
            required: false,
            default: null,
        },
        bgVideo: {
            type: String,
            required: false,
            default: null,
        },
        bgVideoMobile: {
            type: String,
            required: false,
            default: null,
        },
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            required: false,
            default: null,
        },
        youtubeId: {
            type: String,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            gh: gh,
        };
    },
    mounted() {
        this.animate();
    },
    methods: {
        openYoutube(youtubeId) {
            this.$store.commit('openPopup', {youtubeId: youtubeId});
        },
        animate() {
            // Fade in the background image
            if (this.$refs.bgImage) {
                gsap.fromTo(
                    this.$refs.bgImage,
                    { opacity: 0, filter: "grayscale(50%)", scale:1.1 },
                    { opacity: 1, filter: "grayscale(0%)", scale:1, duration: 1, ease: "power2.out" }
                );
            }
            if (this.$refs.bgImageMobile) {
                gsap.fromTo(
                    this.$refs.bgImageMobile,
                    {opacity: 0, filter: "grayscale(50%)", scale: 1.1},
                    {opacity: 1, filter: "grayscale(0%)", scale: 1, duration: 1, ease: "power2.out"}
                );
            }

            // Fade in subtitle
            if (this.$refs.subtitle) {
                gsap.fromTo(
                    this.$refs.subtitle,
                    { opacity: 0, y: 20 },
                    { opacity: 1, y: 0, duration: 0.75, ease: "power2.out", delay: 0.5 }
                );
            }

            // Animate title word-by-word
            if (this.$refs.title) {
                let splitTitle = new SplitText(this.$refs.title, { type: "words" });
                gsap.set(this.$refs.title, { opacity: 1 });
                gsap.fromTo(
                    splitTitle.words,
                    { opacity: 0, y: 15 },
                    {
                        opacity: 1,
                        y: 0,
                        duration: 0.75,
                        delay: 0.7,
                        ease: "power2.out",
                        stagger: 0.1,
                    }
                );
            }
        },
    },
};
</script>